import { render } from "./AddServiceModal.vue?vue&type=template&id=33c2b22e&scoped=true"
import script from "./AddServiceModal.vue?vue&type=script&lang=ts"
export * from "./AddServiceModal.vue?vue&type=script&lang=ts"

import "./AddServiceModal.vue?vue&type=style&index=0&id=33c2b22e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-33c2b22e"

export default script